<script>
import processed from "./components/feedback/processed.vue";
import toBeProcessed from "./components/feedback/toBeProcessed.vue";
export default {
  name: "index",
  components: {processed, toBeProcessed},
  data() {
    return {
      activeName: 'first'
    };
  },
  created() {
    this.$route.query?.activeName && (this.activeName = this.$route.query.activeName);
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
}
</script>

<template>
  <div class="container">
    <!--    <p class="title-text">投诉建议处理</p>-->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="待处理" name="first"><toBeProcessed v-if="activeName === 'first'"></toBeProcessed></el-tab-pane>
      <el-tab-pane label="已处理" name="second"><processed v-if="activeName ==='second'"></processed></el-tab-pane>
    </el-tabs>
  </div>
</template>

<style scoped lang="scss">
.container {
  margin: 18px;
  padding: 30px;
  width: calc(100% - 96px);
  height: calc(100% - 96px);
  background: #FFFFFF;
  overflow: scroll;
  scrollbar-width: none;
  .title-text{font-size: 18px;color: #242D33;position: relative;margin-bottom: 15px;
    &:before{position: absolute;content: '';left: -30px;top: 4px;width: 4px;height: 20px;background: #3984F5;}
  }
  // tags样式修改
  ::v-deep .el-tabs__nav-wrap::after{
    background: #EEEFF2;
    height: 1px;
  }
  ::v-deep .el-tabs__item.is-active{
    color: #3984F5;
    font-weight: bold;
  }
  ::v-deep .el-tabs__item{
    &:hover{
      color: #3984F5;
    }
  }
}
</style>